<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5><i class="fa fa-fw fa-cubes mr-2" />Kategori</h5>
            <hr />
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="input.filter"
                            type="search"
                            id="filterInput"
                            placeholder="Nama"
                        />
                    </div>
                </b-form-group>
                <b-button class="mb-3" variant="primary" @click="$bvModal.show('modal-input')">Buat Kategori Baru</b-button>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive class="mb-3"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="input.filter"
                @filtered="onFiltered"
            >
                <template v-slot:empty>
                    Tidak ada kategori.
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Edit" @click="openEditModal(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :totalRows="totalRows"
                    :per-page="perPage"
                />
            </div>
        </b-card>
        <b-modal id="modal-input" title="Buat Kategori Baru"
            centered no-close-on-backdrop hide-footer
            @shown="$refs.inputName.focus()"
        >
            <b-form-group label="Nama">
                <b-form-input ref="inputName" v-model="input.name" @keyup.enter="executeInput" maxlength="50" />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeInput">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-edit" title="Edit Kategori"
            centered no-close-on-backdrop hide-footer
            @shown="$refs.editName.focus()"
        >
            <b-form-group label="Nama">
                <b-form-input ref="editName" v-model="input.editName" @keyup.enter="executeEdit" maxlength="50" />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeEdit">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'kategori',
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            input: {
                name: "",
                editName: "",
                filter: null
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "name", label: "Nama Kategori", sortable: true },
                { key: "action", label: "Aksi"},
            ],

            items: [],
            activeItem: null,
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            Promise.all([getItems]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        getItems() {

            let query = ""

            this.isBusy = true
            this.items = []

            return this.$axios.get("kategori/").then(res => {

                this.items = res.data
                this.totalRows = res.data.length

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        executeInput() {

            if(this.$helper.isBlank(this.input.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            let payload = new FormData()
            payload.append("name", this.input.name)

            this.isSubmitting = true
            this.$axios.post("kategori/", payload).then(res => {

                let data = {
                    id: res.data.id,
                    name: res.data.name
                }

                this.items.push(data)
                this.totalRows++

                this.$bvModal.hide("modal-input")
                this.$helper.toastSuccess(this, "Kategori baru berhasil ditambahkan!")
                this.input.name = ""

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeEdit() {

            if(this.$helper.isBlank(this.input.editName)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            let payload = new FormData()
            payload.append("id", this.activeItem.id)
            payload.append("name", this.input.editName)

            this.isSubmitting = true
            this.$axios.post("kategori/", payload).then(res => {

                this.activeItem.name = payload.get("name")
                this.$bvModal.hide("modal-edit")
                this.$helper.toastSuccess(this, "Kategori berhasil diubah!")

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        openEditModal(item) {

            this.activeItem = item
            this.input.editName = item.name
            this.$bvModal.show("modal-edit")

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        }

    },

    created(){
        this.init()
    }
}
</script>
